export enum DraggedElementKind {
	Booking = 'booking',
	WaitListItem = 'wait-list-item',
}
